"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmulatorConnector = void 0;
const firestore_1 = require("firebase/firestore");
const auth_1 = require("firebase/auth");
const functions_1 = require("firebase/functions");
/**
 * Emulator Connector
 * Handles connecting Firebase services to local emulators in development
 */
class EmulatorConnector {
    constructor() {
        this.connectedServices = new Set();
    }
    connectFirestore(firestore, port) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.connectedServices.has('firestore')) {
                console.log('🔥 EmulatorConnector: Firestore emulator already connected');
                return;
            }
            try {
                // Check if already connected to avoid errors
                const firestoreSettings = (_b = (_a = firestore._delegate) === null || _a === void 0 ? void 0 : _a._databaseId) === null || _b === void 0 ? void 0 : _b.database;
                if (firestoreSettings === null || firestoreSettings === void 0 ? void 0 : firestoreSettings.includes('emulator')) {
                    console.log('🔥 EmulatorConnector: Firestore already connected to emulator');
                    this.connectedServices.add('firestore');
                    return;
                }
                (0, firestore_1.connectFirestoreEmulator)(firestore, 'localhost', port);
                this.connectedServices.add('firestore');
                console.log(`🔥 EmulatorConnector: Connected Firestore to emulator on port ${port}`);
            }
            catch (error) {
                console.warn('🔥 EmulatorConnector: Failed to connect Firestore emulator:', error);
            }
        });
    }
    connectAuth(auth, port) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.connectedServices.has('auth')) {
                console.log('🔑 EmulatorConnector: Auth emulator already connected');
                return;
            }
            try {
                const authConfig = auth.config;
                if (authConfig === null || authConfig === void 0 ? void 0 : authConfig.emulator) {
                    console.log('🔑 EmulatorConnector: Auth already connected to emulator');
                    this.connectedServices.add('auth');
                    return;
                }
                (0, auth_1.connectAuthEmulator)(auth, `http://localhost:${port}`);
                this.connectedServices.add('auth');
                console.log(`🔑 EmulatorConnector: Connected Auth to emulator on port ${port}`);
            }
            catch (error) {
                console.warn('🔑 EmulatorConnector: Failed to connect Auth emulator:', error);
            }
        });
    }
    connectFunctions(functions, port) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.connectedServices.has('functions')) {
                console.log('⚡ EmulatorConnector: Functions emulator already connected');
                return;
            }
            try {
                const functionsUrl = functions._url;
                if (functionsUrl === null || functionsUrl === void 0 ? void 0 : functionsUrl.includes('localhost')) {
                    console.log('⚡ EmulatorConnector: Functions already connected to emulator');
                    this.connectedServices.add('functions');
                    return;
                }
                (0, functions_1.connectFunctionsEmulator)(functions, 'localhost', port);
                this.connectedServices.add('functions');
                console.log(`⚡ EmulatorConnector: Connected Functions to emulator on port ${port}`);
            }
            catch (error) {
                console.warn('⚡ EmulatorConnector: Failed to connect Functions emulator:', error);
            }
        });
    }
    connectAll(services, ports) {
        return __awaiter(this, void 0, void 0, function* () {
            const connections = [];
            if (services.firestore && ports.firestore) {
                connections.push(this.connectFirestore(services.firestore, ports.firestore));
            }
            if (services.auth && ports.auth) {
                connections.push(this.connectAuth(services.auth, ports.auth));
            }
            if (services.functions && ports.functions) {
                connections.push(this.connectFunctions(services.functions, ports.functions));
            }
            yield Promise.all(connections);
        });
    }
    isConnected(service) {
        return this.connectedServices.has(service);
    }
    getConnectedServices() {
        return Array.from(this.connectedServices);
    }
}
exports.EmulatorConnector = EmulatorConnector;
